/* eslint-disable camelcase */
import React, {
  memo,
  useEffect,
  useCallback,
  useRef,
  useState,
  useMemo,
} from 'react';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, Select, Autocomplete } from '~/components/Form';
// import { TANQUES, VISCOSIDADE } from '~/constants/modules';
import { t, can } from '~/helpers';
import { validation, validationErrors } from '~/helpers/yupValidations';

import * as S from './styles';

function Form({ data, arms, sending, close, onForm, ehCarregamento }) {
  const formRef = useRef(null);

  const [showUsaViscosidade, setShowUsaViscosidade] = useState(0);

  const [hiddens, setHiddens] = useState({
    nomeabreviadoproduto: null,
  });

  const checkUsaViscosidade =
    showUsaViscosidade === 0 ||
    showUsaViscosidade === undefined ||
    showUsaViscosidade === null;

  const medidores = useMemo(
    () =>
      ehCarregamento
        ? [
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
          ]
        : [
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
          ],
    []
  );

  // Submit form data
  const handleSubmit = useCallback(
    async (values) => {
      try {
        const schema = Yup.object().shape({
          medidorpresetproduto: ehCarregamento
            ? Yup.number()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
                .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
                .max(4, t('s.geral.validacao.valormaximo').replace('%s', 4))
            : Yup.number()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
                .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
                .max(10, t('s.geral.validacao.valormaximo').replace('%s', 10)),
          idproduto: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio')),

          alinhadomanualpresetproduto: ehCarregamento
            ? Yup.string()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
          tagpresetcomponente: Yup.string().max(
            6,
            t('s.geral.validacao.valormaximo').replace('%s', 6)
          ),
        });
        await validation(schema, values);
        const formData = {
          id: Math.random().toString(),
          ...data,
          ...values,
          ...hiddens,
          // id_preset_braco: ehCarregamento ? values.id_preset_braco : null,
          alinhadomanualpresetproduto: ehCarregamento
            ? values.alinhadomanualpresetproduto
            : null,
          // id_viscosidade_componente: values?.id_viscosidade_componente ?? null,
          // usa_viscosidade_preset_componente:
          //   values.usa_viscosidade_preset_componente ?? 'N',
        };

        console.log(JSON.stringify(hiddens));

        await onForm(formData);
        await close();
      } catch (error) {
        validationErrors(error, formRef);
      }
    },
    [data, ehCarregamento, hiddens]
  );

  useEffect(() => {
    if (sending) formRef.current.submitForm();
  }, [sending]);

  // Popular hidden type fields
  const handleSetHiddenFields = useCallback((fields = [], dados) => {
    if (!isEmpty(dados)) {
      fields.forEach((field) => {
        setHiddens((state) => ({ ...state, [field]: dados[field] }));
      });
    }
  }, []);

  return (
    <S.Wrapper ref={formRef} initialData={data} onSubmit={handleSubmit}>
      <Select
        name="medidorpresetproduto"
        label={t('s.menu.configuracao.medidor')}
        options={medidores}
      />
      <Autocomplete
        name="idproduto"
        url="/produtos"
        label="nomeabreviadoproduto"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        getValue={(value) =>
          handleSetHiddenFields(['nomeabreviadoproduto'], value)
        }
      />
      <Input
        name="tagpresetproduto"
        label={t('s.operacao.tagrestricao.tagrestricaotag')}
        type="text"
      />
    </S.Wrapper>
  );
}

Form.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  arms: PropTypes.arrayOf(PropTypes.any),
  close: PropTypes.func.isRequired,
  onForm: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  ehCarregamento: PropTypes.bool.isRequired,
};

Form.defaultProps = {
  data: {},
  arms: [],
};

export default memo(Form);
